import React, { Component, Fragment } from "react";
import Async from "react-select";
import { Link } from "react-router-dom"

//components
import QrCode from "../../Common/QrCode";
import Field from "../../Common/Field/Field";
import Button from "../../Buttons/Button";
import CustomerDeptSelect from "../../Field/CustomerDeptSelect";

//options
import options from "../../../services/common/options";

//services
import {
  CustomerServices
} from "../../../services";

export default class LeftSection extends Component {
  state = {
    //options
    styleOptions: "",
    disabled: false,
    SAMPLETYPE: [],
    customerList: [],
    styleNoInfo: [],
    magnumStyleId: "",
    disabled: false,
    toolTip: {},
    action: ""
  };

  componentWillMount() {
    const {
      sampleRequest,
      SAMPLETYPE,
      disabled,
      styleNoInfo,
      magnumStyleId,
      action
    } = this.props;

    this.setState({
      sampleRequest,
      disabled,
      SAMPLETYPE,
      styleNoInfo,
      magnumStyleId,
      action
    });
  }

  componentDidMount() {
    setTimeout(() => {
      this.getCustomerList();
    }, 4500);
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(this.state.SAMPLETYPE).length !=
      Object.keys(nextProps.SAMPLETYPE).length
    ) {
      this.setState({
        SAMPLETYPE: nextProps.SAMPLETYPE
      });
    }

    if (
      nextProps.sampleRequest.customer !== this.state.sampleRequest.customer &&
      nextProps.sampleRequest.customerDepartmentId !==
      this.state.sampleRequest.customerDepartmentId
    ) {
      this.getCustomerList();
    }

    const { sampleRequest, disabled, styleNoInfo, magnumStyleId } = nextProps;

    this.setState({
      sampleRequest,
      disabled,
      styleNoInfo,
      magnumStyleId
    });
  }

  getCustomerList = () => {
    CustomerServices.customerInfo()
      .then(response => {
        if (response.status === 200) {
          this.setState(
            {
              customerList: response.text.data
            },
            () => {
              this.state.customerList &&
                this.state.customerList.length > 0 &&
                this.state.customerList.map(cust => {
                  if (
                    cust.departmentId ===
                    this.state.sampleRequest.customerDepartmentId ||
                    cust.customerName === this.state.sampleRequest.customer
                  ) {
                    const toolTip = {
                      custName: cust.customerName,
                      deptName: cust.departmentName,
                      merchandiser: cust.merchandiser
                    };
                    this.setState(
                      {
                        toolTip
                      },
                      () => {
                        this.props.getCustomerDepartmentName(toolTip);
                      }
                    );
                  }
                });
            }
          );
        }
      })
      .catch(error => { });
  };

  render() {
    const { sampleRequest, SAMPLETYPE, magnumStyleId, styleNoInfo } = this.state;
    let redirectTem;
    if (sampleRequest && sampleRequest.styleReferenceId && styleNoInfo && styleNoInfo.length) {
      let hash = styleNoInfo[0];
      let action = (this.props.action === "add" && "view") || this.props.action;
      let search = "?" + new URLSearchParams({
        action: action,
        _id: sampleRequest.magnumStyleId
      }).toString()
      redirectTem = <Link
        to={{
          pathname: "/StylePage",
          search: search,
          hash: `seleted${hash.label.split("-").join("")}`
        }}
        target="_blank"
      >
        <label
          style={{ cursor: "pointer" }}
        >
          <a className="btn-default">Magnum Style No.</a>
          <span style={{ fontSize: "1.2rem" }} className="text-danger">
            *
                </span>
        </label>
      </Link>
    } else {
      redirectTem = <label style={{ cursor: "pointer" }}><a className="btn-default">Magnum Style No.</a>
        <span style={{ fontSize: "1.2rem" }} className="text-danger">*</span>
      </label>
    }
    return (
      <div className="left-content-section no-padding">
        <div className="col text-center bg-color padding-bottom-bg">
          <h4 className="text-green font-lg font-weight-bold mt-1">
            {sampleRequest.requestNumber}
          </h4>
          <QrCode qr={sampleRequest.qr} />
          <div className="mt-1  p-0">
            <div class="form-group">
              {redirectTem}
              <div class="custom-async-select">
                <Async
                  name="styleReferenceId"
                  value={sampleRequest.styleReferenceId}
                  onInputChange={value => this.props.getMagnumStyleNo(value)}
                  onChange={val =>
                    this.props.getStyleReferenceInfo(
                      val !== null ? val.value : null
                    )
                  }
                  placeholder="Find Style"
                  options={this.state.styleNoInfo}
                  disabled={this.state.disabled}
                  onSelectResetsInput={false}
                  onBlurResetsInput={false}
                />
              </div>
            </div>
          </div>
          <div className=" mt-1  p-0">
            <Field
              isFormGroup={true}
              inputType="text"
              inputName="magnumStyleName"
              value={sampleRequest.magnumStyleName}
              label={"Magnum Style Name*"}
              onChange={this.props.updateSampleRequest}
              disabled={true}
            />
          </div>
          <div className=" mt-1  p-0">
            <Field
              isFormGroup={true}
              inputType="text"
              inputName="customerRefNumber"
              value={sampleRequest.customerRefNumber}
              label={"Cust Ref No."}
              onChange={this.props.updateSampleRequest}
              disabled={true}
            />
          </div>
          <div className="mt-1  p-0">
            <CustomerDeptSelect
              value={`${sampleRequest.customer}-${sampleRequest.customerDepartmentId}`}
              toolTip={this.state.toolTip}
              options={this.state.customerList}
              onChange={this.props.updateCustomerDept}
              disabled={true}
            />
          </div>
          <div className="mt-1  p-0">
            <Field
              isFormGroup={true}
              inputType="select"
              inputName="typeOfRequest"
              value={sampleRequest.typeOfRequest}
              options={options.typeOfRequest}
              label={"Source of Request*"}
              onChange={this.props.updateSampleRequest}
              disabled={this.state.disabled}
            />
          </div>
          <div className="mt-1  p-0">
            <Field
              isFormGroup={true}
              inputType="select"
              inputName="sampleType"
              value={sampleRequest.sampleType || ""}
              options={SAMPLETYPE}
              label={"Sample Type*"}
              onChange={this.props.updateSampleRequest}
              disabled={this.state.disabled}
            />
          </div>
          <div className="p-0">
            {/* {!this.state.disabled && <Button
              buttonType = {'save'}
              buttonName = {'save'}
              onClick = {this.props.saveSampleRequest}
            />} */}
          </div>
        </div>
      </div>
    );
  }
}

LeftSection.propTypes = {};

LeftSection.defaultProps = {};


// WEBPACK FOOTER //
// ./src/components/SampleRequest/LeftSection/index.js